/**
 * 장례식장 상세 페이지 강화 템플릿(Enrichment) 롤아웃에서 제외할 parlor ID 목록 (포털별).
 * 출처: GA4 platform-data-381405.analytics_407259612, 2026-05-08 ~ 2026-07-02 (8주) page_view 상위 10개.
 *
 * 배경: metro는 mismatch 대상(PARLOR_INDEX_MISMATCH_IDS)에만 강화 템플릿을 적용했고,
 * 흡수 해소 이후에도 강화 그룹이 지속 상승 (W23~W26 검색유입 +76% vs 비강화 -33%).
 * 이에 metro 외 5개 포털에 강화 템플릿을 전면 적용하되,
 * 유입 상위 10개(잘 되고 있는 페이지)는 회귀 위험 회피를 위해 기존 템플릿을 유지한다.
 *
 * 게이트: showEnrichedSections = !TOP10.has(id) && !isExcludeAll
 * (metro 는 이 리스트와 무관 - 기존 PARLOR_INDEX_MISMATCH_IDS 게이트 유지)
 *
 * 주의: Top10 중 2026-05-20부터 이미 강화 상태였던 ID(기존 mismatch 대상)는
 * 이 리스트에 넣으면 강화가 해제(회귀)되므로 제외한다. "잘 되던 모습"이 강화
 * 버전이었기 때문. 해당 ID: ch 127·391, gyeongsang 273·366, honam 312·847·901·904
 */

// gyeongsang-portal.co.kr/funeral-companies/{id}/
const GYEONGSANG_ENRICHMENT_EXCLUDE_IDS = new Set<string>([
  "40", "47", "284", "192", "627", "38", "79", "32",
]);

// dggb-portal.funeralblog.co.kr/funeral-places/{id}/
const DGGB_ENRICHMENT_EXCLUDE_IDS = new Set<string>([
  "1146", "514", "994", "631", "624", "74", "610", "86", "1071", "136",
]);

// honam-funeralcenter.co.kr/funeral-recommend-items/{id}/
const HONAM_ENRICHMENT_EXCLUDE_IDS = new Set<string>([
  "908", "92", "83", "268", "763", "625",
]);

// ch-funeralportal.co.kr/parlor-items/{id}/
const CH_ENRICHMENT_EXCLUDE_IDS = new Set<string>([
  "543", "413", "732", "512", "467", "522", "1060", "88",
]);

// gangwon-portal.co.kr/gangwon-parlor-places/{id}/
const GANGWON_ENRICHMENT_EXCLUDE_IDS = new Set<string>([
  "31", "791", "49", "84", "253", "24", "662", "441", "104", "563",
]);

export const PARLOR_ENRICHMENT_EXCLUDE_IDS = {
  gyeongsang: GYEONGSANG_ENRICHMENT_EXCLUDE_IDS,
  dggb: DGGB_ENRICHMENT_EXCLUDE_IDS,
  honam: HONAM_ENRICHMENT_EXCLUDE_IDS,
  ch: CH_ENRICHMENT_EXCLUDE_IDS,
  gangwon: GANGWON_ENRICHMENT_EXCLUDE_IDS,
} as const;
